import { render, staticRenderFns } from "./NewUserForm.vue?vue&type=template&id=f1adf5d6&scoped=true&"
import script from "./NewUserForm.vue?vue&type=script&lang=js&"
export * from "./NewUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1adf5d6",
  null
  
)

export default component.exports